import { render, staticRenderFns } from "./ModalAddressDetail.vue?vue&type=template&id=5e675a24&scoped=true&"
import script from "./ModalAddressDetail.vue?vue&type=script&lang=js&"
export * from "./ModalAddressDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddressDetail.vue?vue&type=style&index=0&id=5e675a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e675a24",
  null
  
)

export default component.exports